import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useEffect, useState } from "react";
import AppLoadingText from "../../../ui/appLoadingText/AppLoadingText";
import MessageAvatar from "./MessageAvatar";

const ETAPAS_PENSANDO_ASSISTENTE = [
	"Lendo o contexto...",
	"Conferindo filtros e agrupamentos...",
	"Preparando uma resposta objetiva...",
] as const;

export default function ThinkingBubble() {
	const [etapaAtual, setEtapaAtual] = useState(0);

	useEffect(() => {
		const intervalId = globalThis.setInterval(() => {
			setEtapaAtual((valorAtual) => (valorAtual + 1) % ETAPAS_PENSANDO_ASSISTENTE.length);
		}, 1200);

		return () => globalThis.clearInterval(intervalId);
	}, []);

	return (
		<div className="animate-app-assistente-message-in flex gap-2">
			<MessageAvatar />
			<div className="max-w-[82%] rounded-2xl rounded-bl-md border bg-background px-3 py-2 shadow-sm shadow-secondary/10">
				<div className="flex items-center gap-2 text-sm font-medium text-foreground">
					<FuseSvgIcon size={16} className="shrink-0 text-secondary">
						lucide:sparkles
					</FuseSvgIcon>
					<AppLoadingText>Pensando...</AppLoadingText>
				</div>
				<p className="mt-1 text-xs leading-5 text-muted-foreground" aria-live="polite">
					{ETAPAS_PENSANDO_ASSISTENTE[etapaAtual]}
				</p>
			</div>
		</div>
	);
}
